import { ReactNode, useEffect, useRef } from 'react';

import { Button } from '@iwoca/orion';

import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { PaymentPlanStatus, Plan } from '../../Dashboard.types';

export const PlanButton = ({
  status,
  selectedPlanId,
  paymentPlan,
  selectPaymentPlan,
  children,
  renderContent,
}: {
  status: PaymentPlanStatus | null;
  selectedPlanId: string | null;
  paymentPlan: Plan;
  selectPaymentPlan: (plan: Plan | null) => void;
  children: ReactNode;
  renderContent?: () => ReactNode;
}) => {
  const isMobile = useMediaQuery('(max-width: 1023px)');
  const isSelected = selectedPlanId === paymentPlan?.pay_link_id;

  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (sectionRef.current && isMobile) {
      // TODO: This is a bit hacky, we should ideally have a more robust way to handle this
      const adjustedTop =
        sectionRef.current.getBoundingClientRect().top + window.scrollY - 180;
      window.scrollTo({ top: adjustedTop, behavior: 'smooth' });
    }
  }, [renderContent, isMobile]);

  return (
    <>
      <button
        className={`w-full cursor-pointer border border-2 bg-structure-100 text-left transition-shadow hover:shadow-blue-s ${
          isSelected ? 'border-primary-40' : 'border-structure-80'
        } ${status === 'overdue' ? 'border-l-4 border-l-error' : ''} rounded-s`}
        onClick={() => {
          if (paymentPlan?.pay_link_id === selectedPlanId) {
            selectPaymentPlan(null);
          } else {
            selectPaymentPlan(paymentPlan);
          }
        }}
      >
        {children}
      </button>
      {isMobile && isSelected && renderContent && (
        <section
          className="mt-s rounded-s border border-structure-80 bg-structure-100 p-l"
          ref={sectionRef}
        >
          {renderContent()}
          <Button
            variant="tertiary"
            className="mt-l w-full"
            onClick={() => selectPaymentPlan(null)}
          >
            Hide details
          </Button>
        </section>
      )}
    </>
  );
};
